<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow"> 
	  
	  <el-form :inline="true" class="demo-form-inline backborder1" size="small">
          <el-form-item ref="choose" :model="choose">
              <el-input placeholder="请输入关键字" v-model="disstrictquery.key" ></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="districtDialog">查询</el-button>
          </el-form-item>
          <el-form-item v-if="actionauth.base_customer_area_add=='true'">
              <el-button type="primary" icon="el-icon-circle-plus-outline"  @click="addistrictDialog = true">新增客户区域</el-button>
          </el-form-item>
      </el-form>
      <div class="backborder2" style="margin-top:10px">   
          <el-table :data="districtlists" v-loading="districtlistsLoading" style="width: 100%">
              <el-table-column label="区域名称" prop="district_name" style="width:90%"></el-table-column>
              <el-table-column label="操作" style="width:10%" align="center" v-if="actionauth.base_customer_area_edit=='true' || actionauth.base_customer_area_del=='true'">
                  <template slot-scope="scope">
                	  <el-button type="primary" size="small" circle icon="el-icon-edit"  @click="editdistrictDialog(scope.row)" v-if="actionauth.base_customer_area_edit=='true'"></el-button>
                	  <el-button type="danger" size="small" circle icon="el-icon-delete" @click="deldistrict(scope.row)" v-if="actionauth.base_customer_area_del=='true'"></el-button>
                  </template>
              </el-table-column>
          </el-table>
          <div class="block">
	          <!--分页begin-->
	          <el-pagination
	            @size-change="districtChooseSizeChange"
	            @current-change="districtChooseCurrentChange"
	            :current-page="disstrictquery.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="disstrictquery.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="district_total_rows">
	          </el-pagination>
	          <!--分页end-->
          </div>
	  </div>
	  
	  <!------------------------添加客户区域管理 start---------------------->
      <el-dialog title="添加客户区域管理" :visible.sync="addistrictDialog" width="30%">
       	  <el-input placeholder="请输入区域名称" size="small" v-model="adddistrict.name"></el-input>
          <div slot="footer" class="dialog-footer">
	          <el-button size="small" @click="addistrictDialog = false">取 消</el-button>
	          <el-button size="small" type="primary" :loading="adddistrictLoading" @click="districtSave">保 存</el-button>
          </div>
      </el-dialog>
      <!------------------------添加客户区域管理 end---------------------->
      
      <!------------------------编辑客户区域管理 start---------------------->
      <el-dialog title="编辑客户区域管理" :visible.sync="editdisDialog" width="30%">
       	  <el-input placeholder="请输入区域名称" size="small" v-model="editdistrict.name"></el-input>
          <div slot="footer" class="dialog-footer">
	          <el-button size="small" @click="editdisDialog = false">取 消</el-button>
	          <el-button size="small" type="primary" :loading="editdistrictLoading" @click="editdistrictSave">保 存</el-button>
          </div>
      </el-dialog>
      <!------------------------编辑客户区域管理 end---------------------->
	     
  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
      actionauth:'', //操作权限
      transitionshow:true,
      url:this.GLOBAL.domain+"Customer/index",
      disstrictquery: {
          act:'districtlists',
          token:this.$cookies.get('token'),
          key:'',
          rollpage: 10,
          p: 1
      },
      districtlists:[],
      districtlistsLoading:false,
      addistrictDialog:false,
      district_total_rows:0,
      editdisDialog:false,
      editdistrict: {
          act:'editdistrict',
          token:this.$cookies.get('token'),
          name:'',
          id:'',
      },
      searchdisstrictquery: {
          act:'districtlists',
          token:this.$cookies.get('token'),
          key:'',
          rollpage: 100000,
          p: 1
      },
      searchdistrictlists:[],
      adddistrict: {
          act:'adddistrict',
          token:this.$cookies.get('token'),
          name:'',
      },
      adddistrictLoading:false,
      selectdisstrictquery: {
          act:'districtlists',
          token:this.$cookies.get('token'),
          key:'',
          rollpage: 10,
          p: 1
      },
      selectdistrictlistsLoading:false,
      selectdistrict:[],
      select_district_total_rows:0,
      editdistrictLoading:false,
      
    }
  },
  mounted(){
      this.getactionauth();
      this.getdistrictlists(); //获取客户区域列表信息
      
  },
  methods:{  
  	//重置表单
    reset() {
        this.$refs.create.resetFields();
    },
  
  	/** 获取操作权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    //编辑客户区域信息
    editdistrictDialog(obj) {
    	this.editdistrict.id=obj.id;
    	this.editdistrict.name=obj.district_name;
    	this.editdisDialog=true;
    },
    
    /** 客户区域管理 **/
    districtDialog() {
    	this.getdistrictlists();
    },
    
    //客户区域列表
    getdistrictlists() {
    	this.districtlistsLoading=true;
    	var resource = this.$resource(this.url);
    	resource.query(this.disstrictquery).then((res) => {
	        if(res.data.Result>0){
	          if(res.data.Result=='70001') this.$router.push('/login')
	          this.$message.error(res.data.Message);
	          this.districtlistsLoading=false;
	        }else{
	          this.districtlists = JSON.parse(Base64.decode(res.data.Data));
          	  this.district_total_rows=parseInt(res.data.count);
	          this.districtlistsLoading=false;
	        }
        }).catch((res) => {
            this.districtlistsLoading=false;
        });
    },
    
    districtChooseSizeChange(val) {
        this.disstrictquery.rollpage = val;
        this.getdistrictlists();
    },
    districtChooseCurrentChange(val) {
        this.disstrictquery.p = val;
        this.getdistrictlists();
    },
    
    /** 获取区域信息列表 **/
    getsearchdistrictlsits() {
    	var resource = this.$resource(this.url);
    	resource.query(this.searchdisstrictquery).then((res) => {
	        if(res.data.Result>0){
	          if(res.data.Result=='70001') this.$router.push('/login')
	          this.$message.error(res.data.Message);
	        }else{
	          this.searchdistrictlists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            
        });
    },
    
    //删除区域
    deldistrict(item){
        this.$confirm('此操作将永久删除 ' + item.district_name + ', 是否继续?', '提示', { type: 'warning' }).then(() => {
              // 向请求服务端删除
              var resource = this.$resource(this.url);
              resource.save({ act:'deldistrict',id:item.id,token:this.$cookies.get('token')}).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                  }else{
                    this.$message.success('成功删除了' + item.district_name + '!');
                    this.getdistrictlists();
                    //更新搜索页区域信息
	          	    this.getsearchdistrictlsits();
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
              });
        }).catch(() => {
              this.$message.info('已取消操作!');
        });
    },
    
    /** 保存客户区域 **/
    districtSave() {
    	if(this.adddistrict.name=='' || this.adddistrict.name==null) {this.$message.error('请填写区域名称！');return false;}    	
    	this.adddistrictLoading=true;
    	var resource = this.$resource(this.url);
    	resource.query(this.adddistrict).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.adddistrictLoading=false;
	        }else{
	            this.$message.success('区域：'+this.adddistrict.name+'添加成功!');
	            this.adddistrictLoading=false;
	            this.addistrictDialog=false;
	            this.adddistrict.name='';
	            this.getdistrictlists();
	            this.getselectdistrictlists();
	            //更新搜索页区域信息
	            this.getsearchdistrictlsits();
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.adddistrictLoading=false;
	        this.addistrictDialog=false;
        });
    },
    
    //选择客户区域列表
    getselectdistrictlists() {
    	this.selectdistrictlistsLoading=true;
    	var resource = this.$resource(this.url);
    	resource.query(this.selectdisstrictquery).then((res) => {
	        if(res.data.Result>0){
	          if(res.data.Result=='70001') this.$router.push('/login')
	          this.$message.error(res.data.Message);
	          this.selectdistrictlistsLoading=false;
	        }else{
	          var data = JSON.parse(Base64.decode(res.data.Data));
	          var _this=this;
	          this.selectdistrict=[];
	          this.selectdistrict.push({id:0,district_name:'不选择区域'});
	          data.forEach(function(e,index) {
	          	  _this.selectdistrict.push(e);
	          });
          	  this.select_district_total_rows=parseInt(res.data.count);
	          this.selectdistrictlistsLoading=false;
	        }
        }).catch((res) => {
            this.selectdistrictlistsLoading=false;
        });
    },
    
    //保存编辑客户区域信息
    editdistrictSave() {
    	this.editdistrictLoading=true;
    	var resource = this.$resource(this.url);
    	resource.query(this.editdistrict).then((res) => {
	        if(res.data.Result>0){
	          if(res.data.Result=='70001') this.$router.push('/login')
	          this.$message.error(res.data.Message);
	          this.editdistrictLoading=false;
	        }else{
	          this.$message.success('编辑区域：'+this.editdistrict.name+'成功!');
	          this.editdistrictLoading=false;
	          this.editdisDialog=false;
	          this.getdistrictlists();
	          //更新搜索页区域信息
	          this.getsearchdistrictlsits();
	        }
        }).catch((res) => {
            this.editdistrictLoading=false;
	        this.editdisDialog=false;
        });
    },   
    
    
  }
}
</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/base/Customerdistrict.vue